export default "<h2>Call Log</h2>\n<app-calllog-list>Loading ...</app-calllog-list>\n"